export default {
    routerName: '外国為替詳細',
    exchange: {
        jpy: '100日本円',
        usd: '1米ドル',
        hkd: '1香港ドル',
        eur: '1ユーロ',
        gpb: '1ポンド',
        year: '年',
        month: '月',
        day: '日',
        createTime: '作成日付',
    },
};
